<template>
  <b-container>
    
    <b-row align-h="center">
      <b-img id="signinImg" alt="canary" :src="require('../assets/logo.png')"></b-img>
    </b-row>

    <!-- パスワードリセット画面 -->
    <div v-if="showPasswordResetForm && !showConfirmResetForm">
      <b-row class="signin" align-h="center">
        <b-col cols="12" md="7">
          <b-card class="signin-card">
            <h5 class="mb-3">パスワードのリセット</h5>
            <b-form @submit.prevent="handlePasswordReset">
              <b-form-group label="ユーザー名" label-class="required" class="mb-3">
                <b-form-input
                  v-model="resetUsername"
                  type="text"
                  required
                  placeholder="ユーザー名を入力してください"
                  class="signin-input" />
              </b-form-group>
              <div class="text-left mb-3">
                <small class="password-reset-link">
                  <a href="#" @click.prevent="cancelPasswordReset">サインイン画面に戻る</a>
                </small>
              </div>
              <b-button type="submit" variant="primary" block :disabled="loading" class="signin-button">
                {{ loading ? '送信中...' : 'コードの送信' }}
              </b-button>
              <p v-if="errorMessage" class="text-danger mt-3 mb-0 small">{{ errorMessage }}</p>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- 確認コード入力画面 -->
    <div v-if="showConfirmResetForm">
      <b-row class="signin" align-h="center">
        <b-col cols="12" md="7">
          <b-card class="signin-card">
            <h5 class="mb-3">新しいパスワードの設定</h5>
            <p class="text-muted small mb-3">
              {{ resetUsername }} 宛にメールで送信された確認コードを入力してください。
            </p>
            <b-form @submit.prevent="handleConfirmReset">
              <b-form-group label="確認コード" label-class="required" class="mb-3">
                <b-form-input
                  v-model="confirmationCode"
                  type="text"
                  required
                  placeholder="メールで受信したコードを入力"
                  class="signin-input" />
              </b-form-group>
              <b-form-group label="新しいパスワード" label-class="required" class="mb-3">
                <b-form-input
                  v-model="newPassword"
                  type="password"
                  required
                  placeholder="新しいパスワードを入力"
                  class="signin-input" />
              </b-form-group>
              <b-form-group label="パスワード（確認）" label-class="required" class="mb-3">
                <b-form-input
                  v-model="newPasswordConfirm"
                  type="password"
                  required
                  placeholder="新しいパスワードを再入力"
                  class="signin-input" />
              </b-form-group>
              <div class="text-left mb-3">
                <small class="password-reset-link">
                  <a href="#" @click.prevent="cancelPasswordReset">サインイン画面に戻る</a>
                </small>
              </div>
              <b-button type="submit" variant="primary" block :disabled="loading" class="signin-button">
                {{ loading ? '設定中...' : 'パスワードを設定' }}
              </b-button>
              <p v-if="errorMessage" class="text-danger mt-3 mb-0 small">{{ errorMessage }}</p>
              <b-alert v-if="successMessage" variant="success" show class="mt-3">
                {{ successMessage }}
              </b-alert>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- サインイン画面 -->
    <div v-show="!showPresetParams && showSignIn && !showPasswordResetForm && !showConfirmResetForm">
      <b-row class="signin" align-h="center">
        <b-col cols="12" md="7">
          <b-card class="signin-card">
            <h5 class="mb-3">サインイン</h5>
            <b-form @submit.prevent="handleSignIn">
              <b-form-group label="ユーザー名" label-class="required" class="mb-3">
                <b-form-input
                  v-model="username"
                  type="text"
                  required
                  class="signin-input" />
              </b-form-group>
              <b-form-group label="パスワード" label-class="required" class="mb-2">
                <b-form-input
                  v-model="password"
                  type="password"
                  required
                  class="signin-input" />
              </b-form-group>
              <div class="text-left py-1 mb-4">
                <small class="password-reset-link">
                  <span class="d-none d-sm-inline">パスワードをお忘れの方 : </span>
                  <a href="#" @click.prevent="showPasswordReset">パスワードのリセット</a>
                </small>
              </div>
              <b-button type="submit" variant="primary" block :disabled="loading" class="signin-button">
                {{ loading ? 'サインイン中...' : 'サインイン' }}
              </b-button>
              <p v-if="errorMessage" class="text-danger mt-3 mb-0 small">{{ errorMessage }}</p>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div v-if="showPresetParams && showSignIn">
      <b-row class="my-3" align-h="center">
        下記のサインイン情報を使用します。よろしいですか？<br>
      </b-row>
      <b-row v-if="this.presetUserName">
        <b-col sm="2" offset-sm="3">
          <label>ユーザー名：</label>
        </b-col>
        <b-col sm="4">
          <code>{{ this.presetUserName }}</code>
        </b-col>
      </b-row>
      <b-row v-if="this.presetPassword">
        <b-col sm="2" offset-sm="3">
          <label>パスワード：</label>
        </b-col>
        <b-col sm="4">
          <code>{{ this.presetPassword }}</code>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col class="text-center" v-if="!failure">
          <b-button id="backButton" variant="primary" @click="presetParams">使用する</b-button>
          <span class="mx-2"/>
          <b-button id="sendButton" variant="secondary" @click="unpresetParams">使用しない</b-button>
        </b-col>
        <b-col class="text-center" v-else>
          <span class="caution">情報の設定に失敗しました。画面更新後に再度実行してください。</span><br>
          <br>
          <b-button id="reloadButton" variant="primary" @click="reloadPage">更新</b-button>
        </b-col>
      </b-row>
    </div>

  </b-container>
</template>

<script>
import { Amplify } from 'aws-amplify'
import { signIn, resetPassword, confirmResetPassword } from 'aws-amplify/auth'

// Amplify設定を確実にするための初期化チェック
const ensureAmplifyConfigured = () => {
  try {
    const config = Amplify.getConfig()
    if (!config?.Auth?.Cognito && window.__amplifyConfig__) {
      // eslint-disable-next-line no-console
      console.log('Re-configuring Amplify in Login.vue')
      Amplify.configure(window.__amplifyConfig__, { ssr: false })
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Amplify configuration check error:', error)
  }
}

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      errorMessage: '',
      successMessage: '',
      showPresetParams: false,
      presetUserName: '',
      presetPassword: '',
      failure: false,
      showPasswordResetForm: false,
      showConfirmResetForm: false,
      resetUsername: '',
      confirmationCode: '',
      newPassword: '',
      newPasswordConfirm: ''
    }
  },
  async mounted () {
    await this.handleQueryParams(this.$route.query)
  },
  async beforeRouteUpdate (to, from, next) {
    next()
    await this.handleQueryParams(to.query)
  },
  computed: {
    showSignIn() {
      return !this.$store.state.auth.token || this.presetUserName || this.presetPassword
    }
  },
  methods: {
    async handleQueryParams (query) {
      if (query.userName || query.password) {
        const isAlreadySignedOut = sessionStorage.getItem('presetSignOut') === 'true'

        if (!isAlreadySignedOut && this.$store.state.auth.token) {
          sessionStorage.setItem('presetSignOut', 'true')
          await this.$store.dispatch('app/signOut')
          window.location.href = `/#/signIn?userName=${encodeURIComponent(query.userName || '')}&password=${encodeURIComponent(query.password || '')}`
          return
        }

        sessionStorage.removeItem('presetSignOut')
        this.showPresetParams = true
        this.presetUserName = query.userName || ''
        this.presetPassword = query.password || ''
      }
    },
    showPasswordReset() {
      this.showPasswordResetForm = true
      this.errorMessage = ''
      this.successMessage = ''
      this.resetUsername = this.username
    },
    cancelPasswordReset() {
      this.showPasswordResetForm = false
      this.showConfirmResetForm = false
      this.errorMessage = ''
      this.successMessage = ''
      this.resetUsername = ''
      this.confirmationCode = ''
      this.newPassword = ''
      this.newPasswordConfirm = ''
    },
    async handlePasswordReset() {
      this.loading = true
      this.errorMessage = ''
      this.successMessage = ''
      
      try {
        ensureAmplifyConfigured()
        
        await resetPassword({
          username: this.resetUsername
        })
        
        // 成功したら確認コード入力画面に移動
        this.showPasswordResetForm = false
        this.showConfirmResetForm = true
        this.errorMessage = ''
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Password reset error:', error)
        
        let errorMsg = 'パスワードリセットに失敗しました'
        if (error.name === 'UserNotFoundException') {
          errorMsg = 'ユーザーが見つかりません'
        } else if (error.name === 'InvalidParameterException') {
          errorMsg = 'ユーザー名が正しくありません'
        } else if (error.name === 'LimitExceededException') {
          errorMsg = 'リクエスト回数の上限を超えました。しばらく待ってから再度お試しください。'
        } else if (error.message) {
          errorMsg = error.message
        }
        
        this.errorMessage = errorMsg
      } finally {
        this.loading = false
      }
    },
    async handleConfirmReset() {
      this.loading = true
      this.errorMessage = ''
      this.successMessage = ''
      
      // パスワード一致チェック
      if (this.newPassword !== this.newPasswordConfirm) {
        this.errorMessage = 'パスワードが一致しません'
        this.loading = false
        return
      }
      
      // パスワードの長さチェック
      if (this.newPassword.length < 8) {
        this.errorMessage = 'パスワードは8文字以上で入力してください'
        this.loading = false
        return
      }
      
      try {
        ensureAmplifyConfigured()
        
        await confirmResetPassword({
          username: this.resetUsername,
          confirmationCode: this.confirmationCode,
          newPassword: this.newPassword
        })
        
        this.successMessage = 'パスワードを変更しました。新しいパスワードでサインインしてください。'
        
        // 2秒後にサインイン画面に戻る
        setTimeout(() => {
          this.username = this.resetUsername
          this.cancelPasswordReset()
        }, 2000)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Confirm reset password error:', error)
        
        let errorMsg = 'パスワードの変更に失敗しました'
        if (error.name === 'CodeMismatchException') {
          errorMsg = '確認コードが正しくありません'
        } else if (error.name === 'ExpiredCodeException') {
          errorMsg = '確認コードの有効期限が切れています。最初からやり直してください。'
        } else if (error.name === 'InvalidPasswordException') {
          errorMsg = 'パスワードは大文字、小文字、数字を含む8文字以上で設定してください'
        } else if (error.name === 'LimitExceededException') {
          errorMsg = 'リクエスト回数の上限を超えました。しばらく待ってから再度お試しください。'
        } else if (error.message) {
          errorMsg = error.message
        }
        
        this.errorMessage = errorMsg
      } finally {
        this.loading = false
      }
    },
    async handleSignIn() {
      this.loading = true
      this.errorMessage = ''
      
      try {
        // Amplify設定を確認
        ensureAmplifyConfigured()
        
        const result = await signIn({
          username: this.username,
          password: this.password
        })
        
        // サインインが完了したか確認
        if (result.isSignedIn) {
          // v6ではsignIn完了時点でセッションが確立されている
          // 認証状態を更新してからホームへ遷移
          const authResult = await this.$store.dispatch('app/authUser', { root: true })
          if (authResult) {
            this.$router.push({ name: 'Home' })
          } else {
            // app.errorにエラーメッセージが設定されている場合はそれを使用
            this.errorMessage = this.$store.state.app.error || '認証情報の取得に失敗しました'
          }
        } else {
          // MFAなど追加のステップが必要な場合
          this.errorMessage = '追加の認証が必要です'
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Sign in error:', error)
        
        // エラーメッセージを日本語化
        let errorMsg = 'サインインに失敗しました'
        if (error.name === 'NotAuthorizedException' || error.message?.includes('Incorrect username or password')) {
          errorMsg = 'ユーザー名またはパスワードが違います'
        } else if (error.name === 'UserNotFoundException') {
          errorMsg = 'ユーザーが見つかりません'
        } else if (error.name === 'UserNotConfirmedException') {
          errorMsg = 'ユーザーが確認されていません'
        } else if (this.$store.state.app.error) {
          errorMsg = this.$store.state.app.error
        } else if (error.message) {
          errorMsg = error.message
        }
        
        this.errorMessage = errorMsg
      } finally {
        this.loading = false
      }
    },
    async presetParams () {
      this.username = this.presetUserName
      this.password = this.presetPassword
      this.showPresetParams = false
      
      // 自動的にサインインを試みる
      if (this.username && this.password) {
        await this.handleSignIn()
      }
    },
    unpresetParams () {
      this.showPresetParams = false
    },
    reloadPage () {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
#signinImg {
  margin: 20px;
}

.signin-card {
  background-color: rgb(152, 251, 152);
  border: 1px solid #2e7d32;
  border-radius: 8px;
  padding: 0.5rem;
  max-width: 380px;
  margin: 0 auto;
}

.signin-card h5 {
  font-weight: normal;
  color: #333;
  font-size: 1.1rem;
  text-align: left;
  margin-bottom: 1rem;
}

.form-group label {
  font-size: 0.9rem;
  color: #333;
  margin-bottom: 0.3rem;
}

.form-group label.required::after {
  content: " *";
  color: red;
}

.signin-input {
  background-color: white;
  border: 1px solid #ccc;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
}

.password-reset-link {
  font-size: 0.85rem;
}

.password-reset-link a {
  color: #0066cc;
  text-decoration: underline;
}

.signin-button {
  background-color: #007bff;
  border-color: #007bff;
  font-weight: normal;
  padding: 0.5rem;
}

.signin-button:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}
</style>